<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "WithNavbar",
};
</script>

<style>
.v-application--wrap {
  min-height: initial;
}

header.px-5.py-5.v-sheet.theme--dark.elevation-0.v-toolbar.v-app-bar.v-app-bar--fixed {
  padding: 0 !important;
  display: flex;
}
</style>
